import {AppConfigService2} from './app-config.service';

export const AppConfigFactory = () => {
  // Create env
  const config = new AppConfigService2();

  // Read environment variables from browser window
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['__config'] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from app-config.js overwrite defaults from the AppConfig.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      config[key] = window['__config'][key];
    }
  }

  return config;
};

export const AppConfigProvider = {
  provide: AppConfigService2,
  useFactory: AppConfigFactory,
  deps: [],
};
